import { Log } from '@/types/logs'

export const checkIsLogUrgent = (log: Log): boolean => {
    if (log.codeTypeReasonInfo?.isUrgent) {
        if (log.codeTypeReasonInfo?.isMechanicalInfoRequired && log.codeTypeReasonInfo?.isOfficialReportRequired) {
            return !log.report && !log.mechanicalInfo
        }

        if (log.codeTypeReasonInfo?.isMechanicalInfoRequired) {
            return !log.mechanicalInfo
        }

        if (log.codeTypeReasonInfo?.isOfficialReportRequired) {
            return !log.report
        }
    }

    return false
}
